<template>
  <div class="lesson" :class="{'lesson--bg': bg}">
    <p class="normal-text">活動型別： {{ identificationMapping[String(lessonData.user_type)] }}</p>
    <p class="normal-text">活動期間：{{ lessonData.formatEventStartTime }}～{{ lessonData.formatEventEndTime }}</p>
    <p class="normal-text">可報名額：{{ lessonData.apply_limit }} 組</p>
    <p class="normal-text">尚餘名額： {{ lessonData.apply_limit - lessonData.apply_count }} 組</p>
    <p class="normal-text">線上報名日期：{{ lessonData.formatApplyStartTime }}～{{ lessonData.formatApplyEndTime }}</p>

    <slot />
  </div>
</template>
<script>
import { defineComponent } from 'vue';
import { identificationMapping } from '@/config/identificaitionConfig';

export default defineComponent({
  name: 'LessonInfo',
  props: {
    lessonData: {
      type: Object,
      default: () => ({}),
    },
    bg: {
      type: Boolean,
      default: true,
    },
  },
  setup() {
    return {
      identificationMapping,
    };
  },
});
</script>
<style lang="scss" scoped>
@import '@/styles/share/pureText.scss';

.lesson {
  margin-top: 85px;
  border-radius: 20px;

  &--bg {
    @include padding(37px 50px);
    background-color: rgba($c-table-row-stripe, 0.2);
  }

  &__box-wrap {
    margin-top: 20px;
  }
}
</style>
